import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "order_no", "date", or "product"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  vendor_from?: string;
  vendor_to?: string;
  product_from?: string;
  product_to?: string;
  dept_from?: string;
  dept_to?: string;
}

export interface ReportRow {
  FD120_01: string;      // order no
  FD120_11: string;      // order date
  FD120_12: string;      // vendor code
  vendor_name: string;
  FD120_17: string;      // dept code
  dept_name: string;
  FD121_10: string;      // product code 1
  FD121_11: string;      // product code 2
  product_code: string;  // concatenated
  FD121_15: number;      // qty
  FD121_16: string;      // unit
  FD121_17: number;      // unit price
  FD121_18: number;      // amount
}

export interface VendorCount {
  code: string;
  name: string;
  count: number;
}

export interface UnitSummary {
  FD121_16: string;   // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: VendorCount[];
  unit_summary: UnitSummary[];
  message?: string;
}

export const d302Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d302/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d302/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
